export
const handleOutsideClick = (event, closeModal) => {
  if (
    !event.target.closest('.modal-content') &&
    !event.target.closest('.accordion')
  ) {
    closeModal()
  }
}
